import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import { configSumoMeta, logger } from '@origin-digital/reporting-client';
import { fetchAppContextV2 } from '../api/sacDapi';

var fetchSac = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sacHost, updateState, onError) {
    var appContext;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchAppContextV2(sacHost);

          case 3:
            appContext = _context.sent;

            if (appContext) {
              updateState(appContext);

              if (configSumoMeta) {
                configSumoMeta({
                  bpid: appContext.businessPartnerId,
                  customerCode: appContext.customerCode
                });
              }
            } else {
              logger.error('@od/sac: null appContext while fetching appContext');
              onError();
            }

            _context.next = 11;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            logger.error('@od/sac: error while fetching appContext', _context.t0);
            onError();

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function fetchSac(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export { fetchSac };